import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageCrewHurtEnergy {
  crewId: number
  newEnergyPoints: number
}

export const voyageMessageId = EVoyageMessage.CrewHurtEnergy

export function write(m: IMessageWriter, d: IMessageCrewHurtEnergy) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write16(m, d.newEnergyPoints)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageCrewHurtEnergy = {
    crewId: messageWriter.read32(m),
    newEnergyPoints: messageWriter.read16(m),
  }

  return d
}

export function test() {
  let ex: IMessageCrewHurtEnergy = {
    crewId: 100,
    newEnergyPoints: 55,
  }
  messageWriter.test('crew-energy-hurt', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  voyageCrew.networkHurtEnergy(msg)
}

export function sendMessageAndImmediatelyExecute(msg: IMessageCrewHurtEnergy) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
